import { memo } from 'react';
import { Link } from 'react-router-dom';
import { AppBar, Grid, IconButton } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { SideDoorIcon } from '@client/images/logos/SideDoorIcon';
import { DocumentTitle } from '@client/components/common/DocumentTitle';
import { appBar } from '@client/theme/mixins';
import { Drawer } from '@client/components/Main/MainNav/Drawer';
import { CreateShowCallButton } from '../common/CreateShowCallButton';
import { ConnectMap } from './ConnectMap';
import { FilterBar } from './FilterBar';
import { MobileDrawer } from './MobileDrawer';

const useStyles = makeStyles()((theme) => ({
  appBar: {
    ...appBar(theme),
    alignItems: 'flex-start',
    justifyContent: 'center',
    borderBottomColor: theme.palette.divider,
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
    marginBottom: 0,
    padding: theme.spacing(0, 2),
  },
  gridToolbarContainer: {
    height: '100%',
    width: '100%',

    [theme.breakpoints.down('sm')]: {
      maxWidth: 'calc(100% - 50px)',
    },
  },
  iconContainer: {
    display: 'none',

    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
  },
  filterBarContainer: {
    [theme.breakpoints.down('sm')]: {
      flex: '1 0 auto',
      maxWidth: '100%',
    },
  },
  mapContainer: {
    position: 'absolute',
    top: theme.spacing(8),
    left: 0,
    height: `calc(100vh - ${theme.heights.MobileAppBar}px - 100px)`, // minus the toolbar and the bottom navigation bar
    width: '100vw',
  },
}));

export const Mobile = memo(() => {
  const { classes } = useStyles();

  return (
    <>
      <DocumentTitle title="Connect" />

      <AppBar
        position="fixed"
        className={classes.appBar}
      >
        <Grid
          container
          spacing={0}
          flexWrap="nowrap"
          className={classes.gridToolbarContainer}
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid
            item
            className={classes.iconContainer}
          >
            <IconButton
              size="xlarge"
              component={Link}
              to="/home"
              edge="start"
              aria-label="Go to front page"
              title="Home"
              id="sda-nav-logo-button"
            >
              <SideDoorIcon />
            </IconButton>
          </Grid>

          <Grid
            item
            zeroMinWidth
            className={classes.filterBarContainer}
          >
            <FilterBar />
          </Grid>

          <Grid item>
            <Drawer />
          </Grid>
        </Grid>
      </AppBar>

      <div className={classes.mapContainer}>
        <ConnectMap />

        <CreateShowCallButton />
      </div>

      <MobileDrawer />
    </>
  );
});

export default Mobile;
